// @ts-nocheck

import React, { useMemo } from 'react';
import styled from 'styled-components';

import { BoomLockImg } from '../../assets/img';
import { useBoomContext } from '../../contexts/BoomContext';
import { useBoomStepContext } from '../../contexts/BoomStepContext';
import { BoomStepStatuses } from '../../types/steps';
import BoomStepDetailsInfoContainer from '../BoomStepDetailsInfo/BoomStepDetailsInfoContainer';
import BoomStepInfoContainer from '../BoomStepInfo/BoomStepInfoContainer';
import BoomViewWrapper from '../BoomViewWrapper';
import BoomBoxWrapper from '../common/BoomBoxWrapper';
import BoomItem from '../common/BoomItem';

const StyledBoomStepInfoContainer = styled(BoomStepInfoContainer)`
  margin-top: 1em;
`;

const BoomStepDetailsInfoWrapper = styled(BoomBoxWrapper)`
  padding: 0.6em 0.7em;
`;

const LockerImg = styled.img`
  position: absolute;
  top: 2em;
  right: 2em;

  height: 4em;
`;

type PropsType = {
  className?: string;
  betslipReference: string;
  stepIndex: number;
};

const BoomStepView = ({ className = '', betslipReference, stepIndex }: PropsType) => {
  const { stepId, stepStatus } = useBoomStepContext();
  const { skinId } = useBoomContext();

  const showLocker = useMemo(() => stepStatus === BoomStepStatuses.LOCKED, [stepStatus]);

  const isWon = useMemo(() => stepStatus === BoomStepStatuses.WON, [stepStatus]);

  return (
    <BoomViewWrapper data-testid={`boom-step-view-${stepId}`} className={className} isExtendedShadow>
      {showLocker ? <LockerImg data-testid={'locker'} src={BoomLockImg} /> : null}
      <BoomItem skinId={skinId} nbWonSteps={stepIndex} isStepView />
      <BoomStepDetailsInfoWrapper isSuccess={isWon}>
        <BoomStepDetailsInfoContainer stepId={stepId} nbWonSteps={stepIndex} stepStatus={stepStatus} isAlginItemRight />
      </BoomStepDetailsInfoWrapper>
      <StyledBoomStepInfoContainer betslipReference={betslipReference} />
    </BoomViewWrapper>
  );
};

export default BoomStepView;
